import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ce2e9676"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "body-container" }
const _hoisted_2 = { class: "SessionPopup" }
const _hoisted_3 = { class: "content flex-1 w-full h-screen overflow-y-auto" }
const _hoisted_4 = { class: "page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newNavBar = _resolveComponent("newNavBar")!
  const _component_SessionPopup = _resolveComponent("SessionPopup")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_newNavBar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SessionPopup)
    ]),
    (_ctx.isSessionPopupVisible == true)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["overlay", { active: 'isOverlayActive' }])
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createVNode(_component_Footer)
    ])
  ]))
}